exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-over-comp-area {\n  display: flex;\n  font-size: 14px;\n  font-weight: 400;\n  flex-direction: column;\n}\n.pop-over-comp-area .show-master {\n  cursor: pointer;\n  color: #31c670;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.pop-over-comp-area .revert-master {\n  cursor: pointer;\n  color: #00b5ff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.private-conflict-icon i {\n  text-decoration: none;\n}\n", ""]);

// exports
